export default __webpack_public_path__ + "static/media/web.7ff498b7.png";